import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const loader = () =>
  import(/* webpackChunkName: "4-feat-usagepolicydialoglifecycle" */ './UsagePolicyDialogLifecycle').then((module) => ({
    default: module.UsagePolicyDialogLifecycle,
  }));

export const LoadableUsagePolicyDialogLifecycle = lazyLoadOnRender({ loader });
